class VideoBadge extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    // Check if video media exists on DOM
    const videoMedia = document.querySelector('.product-gallery__media.video-item');
    if (videoMedia) {
      this.classList.add('active');
    }

    // Add click listener
    this.addEventListener('click', this.handleClick);
  }

  handleClick() {
    const thumbnail = document.querySelector('.product-gallery__thumbnail.video-thumbnail');

    // Trigger thumbnail click
    if (thumbnail) thumbnail.click();

  }
}

window.customElements.define("video-badge", VideoBadge);
